import React from 'react';
import { useTranslation } from 'react-i18next';
import Tip from '../Tip/Tip';
import styles from './sass/OrganizationTips.module.scss';

const TipOrganizationFinancialTrigger = () => {
  const { t } = useTranslation();
  return (
    <Tip
      styleTipTextContainer={styles.triggerContainer}
      styleTriangle={styles.triangle}
    >
      <p>
        {t('tipOrganizationFinancialTrigger')}
      </p>
    </Tip>
  );
};

export default TipOrganizationFinancialTrigger;
